import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ActivatedRoute, Router } from '@angular/router';

import { Title } from '@angular/platform-browser';
import { ProviderService as Service} from '../core/models/provider-service.model';
import { Provider } from '../core/models/provider.model';

import { ProviderService as ProviderService } from '../core/services/provider.service';
import { Observable, tap } from 'rxjs';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { Article } from '../core/models/article.model';
import { ArticleService } from '../core/services/article.service';
import { CartService } from '../core/services/cart.service';

@Component({
  selector: 'app-article',
  templateUrl: './article.page.html',
  styleUrls: ['./article.page.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, SharedModule, HttpClientModule],
  providers: [ ArticleService ]

})
export class ArticlePage implements OnInit {

  article$: Observable<Article>;
  provider$: Observable<Provider>;

  constructor(
    private titleService: Title,
    private providerService: ProviderService,
    private route: ActivatedRoute,
    private articleService: ArticleService,
    public cartService: CartService,
  ) {

    this.article$ = this.articleService.getArticleBySlug$(this.route.snapshot.paramMap.get('articleSlug')).pipe(
      tap( article => this.titleService.setTitle( article.name + ' | Aktualno | dm Studio') )
    );

    this.provider$ = this.providerService.getProvider$();
  }

  ngOnInit() {
    this.titleService.setTitle('Aktualno | dm Studio');
  }


  getImageUrl(id): string {
    switch (parseInt(id)) {
      case 1:
        return 'https://docs.api.pricepilot.io/655b2a9f21e76.jpeg';
      case 3:
        return 'https://docs.api.pricepilot.io/655b1d3703b36.jpeg';
      case 4:
        return 'https://docs.api.pricepilot.io/655b1be684ca8.jpeg';
      default:
        return 'https://docs.api.pricepilot.io/652dadba274e4.jpeg';
    }
  }

  triggerElementClick(elementId:string) {
    const element:HTMLElement = document.getElementById(elementId) as HTMLElement;
    element.click();
  }

}
